import { useState } from "react";
import { baseUrl } from "../../services/helper";
import { toast } from "sonner";
import Modal from "react-modal";
import { Button, Card, Form, Select } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
const { Option } = Select;
Modal.setAppElement("#root");

const Reports = () => {
  const [location, setLocation] = useState("haryana");
  const [reportType, setReportType] = useState("");

  const submitFilter = async () => {
    if (reportType !== "") {
      window.open(
        `${baseUrl}report/download?report_type=${reportType}&state=${location}`,
        "_blank",
        "noopener,noreferrer"
      );
    } else {
      toast.error("please select a report type");
    }
  };

  // - - - - - N E W - - - - -
  const [form] = Form.useForm();

  const states = ["Haryana"];

  const reportTypes = ["B2C Report", "Ecom Report", "HSN Report"];

  return (
    <>
      <div
        style={{
          marginBottom: 24,
          color: "#0471a3",
          fontSize: "1.5rem",
          fontWeight: 600,
        }}
      >
        Generate Report
      </div>
      {/* - - - - - N E W - - - - -  */}
      <div style={{ position: "relative", zIndex: 1, padding: "10px" }}>
        <Card
          style={{
            maxWidth: "100%",
            width: "100%",
            margin: "0 auto",
            borderRadius: "20px",
            border: "1px solid rgba(255, 255, 255, 0.8)",
            background: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(20px)",
          }}
          bodyStyle={{
            padding: "24px",
            transition: "all 0.3s ease",
          }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={submitFilter}
            size="large"
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: "32px",
                transition: "all 0.3s ease",
              }}
            >
              <Form.Item
                name="state"
                label={
                  <span
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: "#374151",
                    }}
                  >
                    Select State
                  </span>
                }
                rules={[{ required: true, message: "Please select a state" }]}
              >
                <Select
                  placeholder="Choose your state"
                  showSearch
                  optionFilterProp="children"
                  dropdownStyle={{
                    borderRadius: "12px",
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                  }}
                  onSelect={(val) => {
                    setLocation(val);
                  }}
                >
                  {states.map((state) => (
                    <Option key={state} value={state}>
                      {state}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="reportType"
                label={
                  <span
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: "#374151",
                    }}
                  >
                    Select Report Type
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please select a report type",
                  },
                ]}
              >
                <Select
                  placeholder="Choose report type"
                  showSearch
                  optionFilterProp="children"
                  dropdownStyle={{
                    borderRadius: "12px",
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                  }}
                  onSelect={(val) => {
                    setReportType(val);
                  }}
                >
                  {reportTypes.map((type) => (
                    <Option key={type} value={type}>
                      {type}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                icon={<DownloadOutlined />}
                className="bg-[#0471a3] border-[#0471a3] hover:bg-[#035e82] focus:outline-none focus:ring-0 shadow-none mt-3 !rounded-md"
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </>
  );
};

export default Reports;
